import { parseCommand } from '../../utils/index.js';
import { ParserKeyError } from '../errors/index.js';
import { FunctionName, ParserStatus } from '../../types/index.js';
export var ReturnTrack;
(function (ReturnTrack) {
    ReturnTrack["ALL"] = "ALL";
    ReturnTrack["MAIN"] = "MAIN";
    ReturnTrack["PROG"] = "PROG";
    ReturnTrack["JOIN"] = "JOIN";
})(ReturnTrack || (ReturnTrack = {}));
export const powerParserKey = 'p';
const parseFromCommand = ({ key: potentialKey, attributes }) => {
    const [key, power] = potentialKey.split('');
    if (!isPowerCommand(key, power)) {
        throw new ParserKeyError('powerParser', key);
    }
    let [track] = attributes;
    if (!Object.values(ReturnTrack).includes(track)) {
        track = ReturnTrack.ALL;
    }
    return {
        key: powerParserKey,
        parser: FunctionName.POWER,
        status: ParserStatus.SUCCESS,
        params: {
            power: parseInt(power),
            track: track
        }
    };
};
function isPowerCommand(key, power) {
    return key === powerParserKey && ['0', '1'].includes(power);
}
export const powerParser = (command) => {
    const commandParams = parseCommand(command);
    return parseFromCommand(commandParams);
};
